import { render, staticRenderFns } from "./RescueDetail.vue?vue&type=template&id=c695e016&"
import script from "./RescueDetail.vue?vue&type=script&lang=js&"
export * from "./RescueDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports